module.exports = __webpack_public_path__ + "img/ios-icon-step1-ipad.2bc64e6b.png";